import { Navigate } from "react-router-dom";

/**
 * La lista de servidores vive en Usuarios.
 * Esta ruta redirige para no duplicar el listado.
 */
export default function ServersPage() {
  return <Navigate to="/users" replace />;
}
